import { render } from "./GroceryProductCard.vue?vue&type=template&id=2fd171df&scoped=true"
import script from "./GroceryProductCard.vue?vue&type=script&lang=js"
export * from "./GroceryProductCard.vue?vue&type=script&lang=js"

import "./GroceryProductCard.vue?vue&type=style&index=0&id=2fd171df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd171df"]])

export default __exports__